import Header from './components/Header';
import HeroSection from './components/HeroSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <IndexSection />
        <CarouselSection />
        <ContactSection />
        <FeaturesSection />
        <MediaSection />
        <FaqSection />
        <CardsSection />
        <AppSection />
        <CommentsSection />
        <RankingSection />
        <TopicsSection />
        <UpdatesSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}